import React from "react";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon, title, description, action, className }) => {
    return (
        <div
            className={cn(
                "flex flex-col items-start gap-3 rounded-xl border border-dashed border-border bg-surface/60 p-8",
                className
            )}
            data-testid="empty-state"
        >
            {Icon && (
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                </div>
            )}
            <div className="space-y-1">
                <h3 className="text-base font-semibold text-foreground">{title}</h3>
                {description && (
                    <p className="text-sm text-muted-foreground max-w-md">{description}</p>
                )}
            </div>
            {action}
        </div>
    );
};
